import { Component } from '@angular/core';

@Component({
  selector: 'xp-invalid-jurisdiction',
  templateUrl: './invalid-jurisdiction.component.html',
  styleUrl: './invalid-jurisdiction.component.scss'
})
export class InvalidJurisdictionComponent {

}
